import axios from "axios";
import {toaster} from "evergreen-ui";
import {hostWithPrefix} from "../common/ApiCommon";

export function getTemplateReq(constructorData, name) {
    const req = {
        id: constructorData.id == null ? null : constructorData.id,
        station: constructorData.station,
        name: name,
        coefficients: {
            a: constructorData.coefficients.A,
            b: constructorData.coefficients.B,
            c: constructorData.coefficients.C,
            d: constructorData.coefficients.D,
        },
        catchmentArea: constructorData.catchmentArea,
        equationString: constructorData.equation,
        filters: constructorData.filters.map((row) => {
            return {
                rainfall: {
                    type: {
                        id: row.rainfall.type.id,
                        name: row.rainfall.type.name
                    },
                    stnEntity: {
                        id: row.rainfall.stnEntity.id,
                        name: row.rainfall.stnEntity.name
                    },
                    code: {
                        id: row.rainfall.code.id,
                        code: row.rainfall.code.code
                    }
                },
                level: {
                    type: {
                        id: row.level.type.id,
                        name: row.level.type.name
                    },
                    stnEntity: {
                        id: row.level.stnEntity.id,
                        name: row.level.stnEntity.name
                    },
                    code: {
                        id: row.level.code.id,
                        code: row.level.code.code
                    }
                }
            }
        })
    }

    return req
}



export function generateRainFloodExcel(period, constructorData, name) {
    const template = getTemplateReq(constructorData)

    const req = {
        name: name,
        period: period,
        template: template
    }

    return axios({
        url: 'http://' + hostWithPrefix + '/api/outputforms/rain_flood', //your url
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify(req),
    });
}

export function generateRiverFloodExcel(period, meltingPeriod, constructorData, name) {
    const template = getTemplateReq(constructorData)

    const req = {
        name: name,
        floodPeriod: period,
        meltingPeriod: meltingPeriod,
        template: template
    }

    return axios({
        url: 'http://' + hostWithPrefix + '/api/outputforms/river_flood', //your url
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify(req),
    });
}

export function saveRainTemplate(constructorData, name) {
    const req = getTemplateReq(constructorData, name)

    axios({
        url: 'http://' + hostWithPrefix + '/templates/rain_flood', //your url
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify(req)
    }).then((response) => {
        toaster.success('Шаблон сохранен!')
    }).catch((err) => {
        if (err.response.status === 400) {
            toaster.danger("Некорректный запрос! Возможно шаблон с таким именем уже существует.")
        } else {
            toaster.danger("Не получилось!")
        }
    });
}

export function saveRiverTemplate(constructorData, name) {
    const req = getTemplateReq(constructorData, name)

    axios({
        url: 'http://' + hostWithPrefix + '/templates/river_flood', //your url
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify(req)
    }).then((response) => {
        toaster.success('Шаблон сохранен!')
    }).catch(err => {
        if (err.response.status === 400) {
            toaster.danger("Некорректный запрос! Возможно шаблон с таким именем уже существует.")
        } else {
            toaster.danger("Не получилось!")
        }
    });
}
